 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-Auth-ResetPassword-vue~view-Auth-SignIn2-vue~view-Contacts-Index-vue~view-Dashboard-vue~view-My~49f114d0":"view-Auth-ResetPassword-vue~view-Auth-SignIn2-vue~view-Contacts-Index-vue~view-Dashboard-vue~view-My~49f114d0","view-Auth-ResetPassword-vue":"view-Auth-ResetPassword-vue","view-Auth-SignIn2-vue":"view-Auth-SignIn2-vue","view-Contacts-Create-vue~view-Contacts-Item-vue~view-Mysteries-Create-vue~view-Mysteries-Item-vue":"view-Contacts-Create-vue~view-Contacts-Item-vue~view-Mysteries-Create-vue~view-Mysteries-Item-vue","view-Mysteries-Create-vue~view-Mysteries-Item-vue":"view-Mysteries-Create-vue~view-Mysteries-Item-vue","view-Mysteries-Create-vue":"view-Mysteries-Create-vue","view-Mysteries-Item-vue":"view-Mysteries-Item-vue","view-Contacts-Index-vue":"view-Contacts-Index-vue","view-Dashboard-vue":"view-Dashboard-vue","view-Mysteries-Index-vue":"view-Mysteries-Index-vue","view-Orders-Index-vue":"view-Orders-Index-vue","view-Auth-SignIn-vue":"view-Auth-SignIn-vue","view-Auth-SignUp-vue":"view-Auth-SignUp-vue","view-Contacts-Create-vue~view-Contacts-Item-vue":"view-Contacts-Create-vue~view-Contacts-Item-vue","view-Contacts-Create-vue":"view-Contacts-Create-vue","view-Contacts-Item-vue":"view-Contacts-Item-vue","view-Layouts-Auth2-vue":"view-Layouts-Auth2-vue","view-Layouts-Content-vue":"view-Layouts-Content-vue","view-Layouts-ContentOverlay-vue":"view-Layouts-ContentOverlay-vue","view-Layouts-Default2-vue":"view-Layouts-Default2-vue","view-Mysteries-Mystery-vue":"view-Mysteries-Mystery-vue","view-Orders-Create-vue":"view-Orders-Create-vue","view-Orders-Item-vue":"view-Orders-Item-vue","view-Orders-Order-vue":"view-Orders-Order-vue","view-Profile-vue":"view-Profile-vue"}[chunkId]||chunkId) + "." + {"chunk-2d0d36c0":"391d7ecc","view-Auth-ResetPassword-vue~view-Auth-SignIn2-vue~view-Contacts-Index-vue~view-Dashboard-vue~view-My~49f114d0":"e82c3a61","view-Auth-ResetPassword-vue":"2c177dca","view-Auth-SignIn2-vue":"a5b5b01d","view-Contacts-Create-vue~view-Contacts-Item-vue~view-Mysteries-Create-vue~view-Mysteries-Item-vue":"f9dfa5c7","view-Mysteries-Create-vue~view-Mysteries-Item-vue":"1b782c50","view-Mysteries-Create-vue":"5abb8e92","view-Mysteries-Item-vue":"71332dcd","view-Contacts-Index-vue":"b29d293c","view-Dashboard-vue":"006ad593","view-Mysteries-Index-vue":"3468b64c","view-Orders-Index-vue":"9cf174b4","view-Auth-SignIn-vue":"4ad66c6f","view-Auth-SignUp-vue":"f8b414f7","view-Contacts-Create-vue~view-Contacts-Item-vue":"d528409a","view-Contacts-Create-vue":"fcfa5110","view-Contacts-Item-vue":"a821672a","view-Layouts-Auth2-vue":"b8ebb849","view-Layouts-Content-vue":"43bb8f12","view-Layouts-ContentOverlay-vue":"0959a8b8","view-Layouts-Default2-vue":"3d81240a","view-Mysteries-Mystery-vue":"2a835cd1","view-Orders-Create-vue":"1b937e6d","view-Orders-Item-vue":"1097820a","view-Orders-Order-vue":"fec75745","view-Profile-vue":"294c4d3c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-Layouts-Auth2-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-Auth-ResetPassword-vue~view-Auth-SignIn2-vue~view-Contacts-Index-vue~view-Dashboard-vue~view-My~49f114d0":"view-Auth-ResetPassword-vue~view-Auth-SignIn2-vue~view-Contacts-Index-vue~view-Dashboard-vue~view-My~49f114d0","view-Auth-ResetPassword-vue":"view-Auth-ResetPassword-vue","view-Auth-SignIn2-vue":"view-Auth-SignIn2-vue","view-Contacts-Create-vue~view-Contacts-Item-vue~view-Mysteries-Create-vue~view-Mysteries-Item-vue":"view-Contacts-Create-vue~view-Contacts-Item-vue~view-Mysteries-Create-vue~view-Mysteries-Item-vue","view-Mysteries-Create-vue~view-Mysteries-Item-vue":"view-Mysteries-Create-vue~view-Mysteries-Item-vue","view-Mysteries-Create-vue":"view-Mysteries-Create-vue","view-Mysteries-Item-vue":"view-Mysteries-Item-vue","view-Contacts-Index-vue":"view-Contacts-Index-vue","view-Dashboard-vue":"view-Dashboard-vue","view-Mysteries-Index-vue":"view-Mysteries-Index-vue","view-Orders-Index-vue":"view-Orders-Index-vue","view-Auth-SignIn-vue":"view-Auth-SignIn-vue","view-Auth-SignUp-vue":"view-Auth-SignUp-vue","view-Contacts-Create-vue~view-Contacts-Item-vue":"view-Contacts-Create-vue~view-Contacts-Item-vue","view-Contacts-Create-vue":"view-Contacts-Create-vue","view-Contacts-Item-vue":"view-Contacts-Item-vue","view-Layouts-Auth2-vue":"view-Layouts-Auth2-vue","view-Layouts-Content-vue":"view-Layouts-Content-vue","view-Layouts-ContentOverlay-vue":"view-Layouts-ContentOverlay-vue","view-Layouts-Default2-vue":"view-Layouts-Default2-vue","view-Mysteries-Mystery-vue":"view-Mysteries-Mystery-vue","view-Orders-Create-vue":"view-Orders-Create-vue","view-Orders-Item-vue":"view-Orders-Item-vue","view-Orders-Order-vue":"view-Orders-Order-vue","view-Profile-vue":"view-Profile-vue"}[chunkId]||chunkId) + "." + {"chunk-2d0d36c0":"31d6cfe0","view-Auth-ResetPassword-vue~view-Auth-SignIn2-vue~view-Contacts-Index-vue~view-Dashboard-vue~view-My~49f114d0":"31d6cfe0","view-Auth-ResetPassword-vue":"31d6cfe0","view-Auth-SignIn2-vue":"31d6cfe0","view-Contacts-Create-vue~view-Contacts-Item-vue~view-Mysteries-Create-vue~view-Mysteries-Item-vue":"31d6cfe0","view-Mysteries-Create-vue~view-Mysteries-Item-vue":"31d6cfe0","view-Mysteries-Create-vue":"31d6cfe0","view-Mysteries-Item-vue":"31d6cfe0","view-Contacts-Index-vue":"31d6cfe0","view-Dashboard-vue":"31d6cfe0","view-Mysteries-Index-vue":"31d6cfe0","view-Orders-Index-vue":"31d6cfe0","view-Auth-SignIn-vue":"31d6cfe0","view-Auth-SignUp-vue":"31d6cfe0","view-Contacts-Create-vue~view-Contacts-Item-vue":"31d6cfe0","view-Contacts-Create-vue":"31d6cfe0","view-Contacts-Item-vue":"31d6cfe0","view-Layouts-Auth2-vue":"8cf34e7b","view-Layouts-Content-vue":"31d6cfe0","view-Layouts-ContentOverlay-vue":"31d6cfe0","view-Layouts-Default2-vue":"31d6cfe0","view-Mysteries-Mystery-vue":"31d6cfe0","view-Orders-Create-vue":"31d6cfe0","view-Orders-Item-vue":"31d6cfe0","view-Orders-Order-vue":"31d6cfe0","view-Profile-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
